<img *ngIf="array" src="/images/{{ imageName }}" [alt]="$any(array)?.name" [style]="style" />
<div class="parallelogram" *ngIf="showModel">
    <div class="model-name">{{ array.model }}</div>
</div>
